<template>
  <div class="balance" :align-right='right'>
    <span @click="() => changeRoute('balance')">
      {{ i18n('balance__text') }}
      <span>{{ eur }} {{ "EUR" | currencyIcon }}</span> |
      <span>{{ usd }} {{ "USD" | currencyIcon }}</span> |
      <span>{{ rub }} {{ "RUB" | currencyIcon }}</span>
    </span>
  </div>
</template>

<script>
import { i18n } from '@/mixins';

export default {
  name: 'Balance',
  props: {
    right: Boolean,
  },
  mixins: [i18n],
  computed: {
    profile() {
      return this.$store.getters['$_user/profile'];
    },
    eur() {
      return this.profile.balance.EUR
        ? this.profile.balance.EUR.approved + this.profile.balance.EUR.hold : 0;
    },
    usd() {
      return this.profile.balance.USD
        ? this.profile.balance.USD.approved + this.profile.balance.USD.hold : 0;
    },
    rub() {
      return this.profile.balance.RUB
        ? this.profile.balance.RUB.approved + this.profile.balance.RUB.hold : 0;
    },
  },
  methods: {
    changeRoute(name) {
      this.$emit('close');
      this.$nextTick(() => this.$router.push({ name }));
    },
  },
};
</script>

<style lang="scss" scoped>
  .balance {
    > span {
      cursor: pointer;
    }
  }
</style>




// WEBPACK FOOTER //
// src/components/Header/components/Balance.vue